"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareEntityEvent = exports.hasEventPatternPrefix = exports.makeEventPattern = exports.EVENT_PATTERN_PREFIX = exports.emitEntityEvent = exports.clearEntityEventEmitters = exports.removeEntityEventEmitter = exports.addEntityEventEmitter = void 0;
let emitters = [];
function addEntityEventEmitter(emitter) {
    if (!emitters.includes(emitter)) {
        emitters.push(emitter);
    }
}
exports.addEntityEventEmitter = addEntityEventEmitter;
function removeEntityEventEmitter(emitter) {
    emitters = emitters.filter((e) => e === emitter);
}
exports.removeEntityEventEmitter = removeEntityEventEmitter;
function clearEntityEventEmitters() {
    emitters = [];
}
exports.clearEntityEventEmitters = clearEntityEventEmitters;
function emitEntityEvent(cls, event, entity, ...args) {
    const eventPayload = prepareEntityEvent(cls, event, entity, args);
    if (eventPayload) {
        if (!emitters || !emitters.length) {
            console.error('No configured EntityEvent emitter');
            return;
        }
        for (const emitter of emitters) {
            emitter(eventPayload.event, eventPayload.entity, eventPayload.args);
        }
        return true;
    }
    return false;
}
exports.emitEntityEvent = emitEntityEvent;
exports.EVENT_PATTERN_PREFIX = process.env.CURRENT_POD_NAMESPACE + '.';
function makeEventPattern(pattern) {
    return `${exports.EVENT_PATTERN_PREFIX}${pattern}`;
}
exports.makeEventPattern = makeEventPattern;
function hasEventPatternPrefix(pattern) {
    return pattern.startsWith(exports.EVENT_PATTERN_PREFIX);
}
exports.hasEventPatternPrefix = hasEventPatternPrefix;
function prepareEntityEvent(cls, event, entity, args) {
    var _a;
    const eventName = (_a = cls.EVENTS) === null || _a === void 0 ? void 0 : _a.getEventFromString(event);
    if (!eventName) {
        return;
    }
    return {
        event: makeEventPattern(eventName),
        entity,
        args,
    };
}
exports.prepareEntityEvent = prepareEntityEvent;
//# sourceMappingURL=emit.js.map